import { createRequestActionTypes } from "../../../shared/utility";

export const AcquirerMngActions = {
    fetchAcquirerDetails: createRequestActionTypes('FETCH_ACQUIRER_DETAILS'), 
    createAcquirer: createRequestActionTypes('CREATE_ACQUIRER'),
    updateAcquirer: createRequestActionTypes('UPDATE_ACQUIRER'),
}